import { useFormContext } from "react-hook-form";
import type { UseMutationOptions } from "react-query";
import { useMutation } from "react-query";
import { workflowsApi } from "@/react/api";
import { minimumDelay } from "@circle-react/helpers/dateTimeHelpers";

export const useRunWorkflow = (
  options: UseMutationOptions<undefined, Error, void> = {},
) => {
  const { watch } = useFormContext<{ id: string }>();
  const id = watch("id");

  return useMutation(
    () => minimumDelay(workflowsApi.createRun({ workflowId: id }), 500),
    {
      onError: error => {
        console.error(error);
      },
      ...options,
    },
  );
};
